import { postRequest } from "@/lib/axios";

export interface TwUserKuangji {
  companyId: number;
  createTime: string;
  floatMin: number;
  id: number;
  kjId: number;
  kjName: string;
  max: number;
  min: number;
  num: number;
  updateTime: string;
  userId: number;
}

export interface UserLoginData {
  addip: string;
  addr: string;
  addtime: number;
  area: string;
  areaCode: string;
  black: number;
  buyOn: number;
  cardfm: string;
  cardsc: string;
  cardzm: string;
  codeAmount: number;
  companyId: number;
  depatmentId: number;
  dupCard: boolean;
  endtime: number;
  grado: number;
  id: number;
  idCard: string;
  invit: string;
  invit1: string;
  invit2: string;
  invit3: string;
  isAgent: number;
  jifen: number;
  lang: string;
  language: string;
  level: number;
  lgtime: string;
  loginaddr: string;
  loginip: string;
  logins: number;
  logintime: string;
  merchandiser: number;
  money: number;
  myzc: number;
  password: string;
  path: string;
  paypassword: string;
  phone: string;
  plainPwd: string;
  realName: string;
  recharge: number;
  rechargeAmount: number;
  rzstatus: number;
  rztime: number;
  rztype: any;
  rzuptime: number;
  status: number;
  stoptime: number;
  token: string;
  tradeMoney: number;
  tradeUsdt: number;
  twUserKuangji: TwUserKuangji[];
  txstate: number;
  type: number;
  upUserId: string;
  usdt: number;
  userCode: string;
  userType: number;
  username: string;
  winOrLose: number;
}

export interface UserLoginResponse {
  code: number;
  data: UserLoginData;
  level: string;
  msg: string;
  ok: boolean;
}

export interface AuthReq {
  companyId?: number;
  idToken?: string;
  invit?: string;
  ip?: string;
  language?: string;
  password?: string;
}


/**
 * Google 登录认证接口
 * @param param AuthReq 参数
 * @returns Promise<UserLoginResponse>
 */
export const googleAuthApi = (param: AuthReq) => {
  return postRequest<UserLoginResponse>('/api/pc/auth/login', param);
};

export interface IsRegisterResponse {
  code: number;
  data: Record<string, any>;
  level: string;
  msg: string;
  ok: boolean;
}

/**
 * 判断用户是否已注册
 * @param param AuthReq 参数
 * @param token 可选，用户token
 * @returns Promise<IsRegisterResponse>
 */
export const isRegisterApi = (param: AuthReq) => {
  return postRequest<IsRegisterResponse>(
    '/api/pc/auth/isRegister',
    param,
  );
};
